import React, { useState, useCallback, useEffect } from 'react'
import Loading from 'custom/assets/loaders/Loading'
import CustomPagination from '../../../components/pagination'
import ApprovalService from '../../../services/approval.service'
import QuickLinkService from '../../../services/quick-link.service'
import LayoutWithOutAccountCard from '../../Layout/layout-without-card'
import { BUTTON_KEYS, SALARY_FILE_STATUS_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next';
import SalaryUploadHeaderDetails from '../../../components/header-details/salaryUpload'
import SalaryUploadDetails from '../../../components/view-details/salaryUpload'


export default function SalaryStatusDownload() {
  const [receiptsDetails, setReceiptsDetails] = useState()
  const [loading, setLoading] = useState(false)
  const [loadingState, setLoadingState] = useState(false)
  const [stage, setStage] = useState(0)
  const [expanded, setExpanded] = useState(null)
  const [noRecords, setNoRecords] = useState(false)
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(10)
  const [invalidList, setInvalidList] = useState([])
  const {t}=useTranslation()
  
  const getSalaryStatus = useCallback(async () => {
    try {
      setLoading(true)
      setStage(0)
      const response = await QuickLinkService.getSalaryStatus()
      if (response.status === 200) {
        setNoRecords(response.data['resp'].length > 0 ? false : true)
        setReceiptsDetails(response.data['resp'])
        setStage(1)
        setLoading(false)
      }
    } catch (err) {
      console.error(err)
      //setStage(1)
      setLoading(false)
    }
  }, [])


  const suStatusRecord = useCallback(async (values) => {
    try {
      setLoadingState(true)
      const reqParams = {
        ...values,
        reqId: values.reqId,
      }
      await QuickLinkService.suStatusRecord(reqParams)
      setLoadingState(false)
    } catch (err) {
      setLoadingState(false)
      console.error(err)
    }
  }, [])

  useEffect(() => {
    getSalaryStatus()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      case 2:
        return renderInvalidList()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div>
        {receiptsDetails !== null && receiptsDetails !== undefined && (
          <>
            <div style={{ justifyContent: ' space-between', alignItems: 'center' }}>
              <div>
                {receiptsDetails.length > 0 ? (
                  receiptsDetails.slice(minValue, maxValue).map((item, index) => (
                    <>
                      <div
                        className='approval-card'
                        onClick={() =>
                          expanded === index ? setExpanded(null) : setExpanded(index)
                        }
                        key={index}>
                        <div>
                          {' '}
                          <SalaryUploadHeaderDetails option={item} />
                        </div>
                        {expanded === index && (
                          <div className='approval-card-body'>
                            <SalaryUploadDetails option={item} />
                            <div
                              className='d-flex'
                              style={{ marginTop: 20, justifyContent: 'center' }}>
                              <a
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  suStatusRecord(item)
                                }}>
                                {t(BUTTON_KEYS.DOWNLOAD)}
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ))
                ) : (
                  <p style={{ textAlign: 'center', marginTop: 20 }}>
                    {t(SALARY_FILE_STATUS_KEYS.NO_RECORDS_FOUND)}
                  </p>
                )}
              </div>

              <div>
                {receiptsDetails.length > 10 && (
                  <CustomPagination
                    defaultPageSize={10}
                    setMaxValue={(value) => {
                      setExpanded(null)
                      setMaxValue(value)
                    }}
                    setMinValue={(value) => setMinValue(value)}
                    totalLength={receiptsDetails.length}
                    defaultCurrent={1}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard
      breadCumKey='SALARY_STATUS_TRANSFER_DOWNLOAD'
      showEmptySpace={true}
      keyPath={'SALARY_STATUS_DOWNLOAD'}>
      <div className='heading-style'>{t(SALARY_FILE_STATUS_KEYS.TITLE)}</div>
      {loading && renderLoading()}
      {!loading && renderSwitch()}
    </LayoutWithOutAccountCard>
  )
}
